// Fuzzball Quiz Debug Helper
// Utility to help test and debug the refactored quiz system

window.QuizDebug = {
  // Check system status
  checkStatus() {
    
    // Check modules loaded
    const modules = [
      'QuizConstants',
      'QuizState',
      'QuizUtils',
      'QuizValidators',
      'QuizCalculator',
      'QuizCartAPI',
      'QuizController',
      'FuzzballQuiz'
    ];
    
    modules.forEach(module => {
    }); 
    
    // Check custom elements
    
    // Check state
    
    // Check localStorage keys
    const quizKeys = Object.keys(localStorage).filter(key => 
      key.includes('quiz') || key.includes('submission') || key.includes('recommendation')
    );
    quizKeys.forEach(key => {
    });
  },
  
  // Clear all quiz data
  clearAll() {
    if (confirm('This will clear all quiz data. Continue?')) {
      window.QuizState.clear();
      window.location.reload();
    }
  },
  
  // Test bundle system
  async testBundleSystem() {
    
    const bundleEl = document.querySelector('quiz-bundle');
    if (!bundleEl) {
      return;
    }
    
  },
  
  // Test trail box
  testTrailBox() {
    
    const trailEl = document.querySelector('trail-box');
    if (!trailEl) {
      return;
    }
    
  },
  
  // Migrate old data
  migrateOldData() {
    
    // Check for old keys
    const oldRecommendations = localStorage.getItem('quizRecommendations');
    if (oldRecommendations && !localStorage.getItem('recommendations')) {
      localStorage.setItem('recommendations', oldRecommendations);
    }
    
    // Ensure disliked_flavors is an array
    const submissionData = localStorage.getItem('submissionData');
    if (submissionData) {
      try {
        const data = JSON.parse(submissionData);
        if (!data.disliked_flavors || !Array.isArray(data.disliked_flavors)) {
          data.disliked_flavors = [];
          localStorage.setItem('submissionData', JSON.stringify(data));
        }
      } catch (e) {
      }
    }
    
    // Reload state
    window.QuizState.loadAll();
  },
  
  // Force recalculate recommendations
  recalculate() {
    const data = window.QuizState.get('submissionData');
    if (!data || !data.fuzzballer_name) {
      return;
    }
    
    const recommendations = window.QuizCalculator.calculate(data);
    window.QuizState.updateRecommendations(recommendations);
    
    // Update bundle system if on step 7
    const bundleEl = document.querySelector('quiz-bundle');
    if (bundleEl && bundleEl.applyQuizRecommendations) {
      bundleEl.applyQuizRecommendations(recommendations);
    }
  },
  
  // Show help
  help() {
    console.log(`
=== Quiz Debug Commands ===

QuizDebug.checkStatus()     - Check system status
QuizDebug.clearAll()        - Clear all quiz data
QuizDebug.testBundleSystem() - Test bundle system
QuizDebug.testTrailBox()    - Test trail box
QuizDebug.migrateOldData()  - Migrate old localStorage data
QuizDebug.recalculate()     - Force recalculate recommendations
QuizDebug.help()            - Show this help

For more detailed debugging, check the browser DevTools:
- Network tab for API calls
- Console for errors
- Application > Local Storage for stored data
    `);
  }
};

// Auto-check on load
setTimeout(() => {
  
  // Check for common issues
  if (!window.QuizController) {
  }
  
  const submissionData = window.QuizState.get('submissionData');
  if (submissionData && !submissionData.disliked_flavors) {
    window.QuizDebug.migrateOldData();
  }
}, 1000);